import React from 'react'
import Link from 'gatsby-link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faInstagram, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons'
import BrandLogo from '../assets/images/Backyard_Bundles_Logo_100px.png'

const NavBar = ({ siteTitle }) => (
    <nav className="navbar has-color-primary" role="navigation" aria-label="main navigation">
        <div className="m-l-md">
            <Link to="/">
                <img src={BrandLogo} />
            </Link>
        </div>
        <div className="navbar-brand is-warning">
            

            {/* <a role="button" className="navbar-burger" aria-label="menu" aria-expanded="false">
                    <span aria-hidden="true">
                        Expo
                    </span>
                    <span aria-hidden="true">
                        Love
                        
                    </span>
                        <span aria-hidden="true"></span>
                </a> */}
        </div>
        <div className="navbar-menu">
            <div className="navbar-end">
                <div className="navbar-item">
                    <div className="field is-grouped">
                        <p className="control has-color-primary">
                            <a href="https://backyardbundles.myshopify.com/collections/bourbon-party-bundles">
                                <FontAwesomeIcon icon={faShoppingCart} size="2x" />
                            </a>
                        </p>
                        <p className="control">
                            <a href="https://www.facebook.com/thebackyardbundles/">
                                <FontAwesomeIcon icon={faFacebook} size="2x" />
                            </a>
                        </p>
                        <p className="control">
                            <a href="https://www.instagram.com/backyardbundles/">
                                <FontAwesomeIcon icon={faInstagram} size="2x" />
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </nav>
)

export default NavBar


// WEBPACK FOOTER //
// ./src/components/navBar.js